import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { all_routes } from "../../Router/all_routes";
import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import TableTop from "../../Components/UI/TableTop";
import { useTableSearch } from "../../core/Operations/useTableSearch";
import { useGetEmployeeQuery } from "../../AppQuries/employee/employee_list";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import {
  Edit,
  PlusCircle,
  Trash2,
} from "feather-icons-react/build/IconComponents";
import { Download, Eye, Upload, Users } from "react-feather";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { format } from "date-fns";
import Error404 from "../ErrorPages/error404";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import useTableExport from "core/Operations/useTableExport";
import { Spin, Table } from "antd";
import { useGetEmpWorkingHourDetailsQuery } from "AppQuries/employee/get-employee-details";
import ReportTools from "Components/UI/ReportTools";
const EmpWorkingHours = () => {
  const userData = useSelector(loggedInUser);
  const route = all_routes;

  // const [searchParams] = useSearchParams();
  

  const [queryParams, setQueryParams] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return {
      groupCode: params.get("groupCode") || "",
      residentialType: params.get("residentialType") || "",
      departmentCode: params.get("departmentCode") || 0,
      gender: params.get("gender") || "",
      nationality: params.get("nationality") || "",
      employmentType: params.get("employmentType") || "",
      employeeType: params.get("employeeType") || "",
    };
  });

  const {
    data: employeeData,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
  } = useGetEmpWorkingHourDetailsQuery({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    ...queryParams,
  });

  const employeeFields = employeeData?.length
    ? Object.keys(employeeData[0]).map((key) => ({
        title: key,
        dataIndex: key,
      }))
    : [];

  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const columns = [
    {
      title: "Emp Code",
      dataIndex: "uniqueId",
      width: 100,
    },
    {
      title: "Emp Name",
      dataIndex: "fullName",
      
      sorter: (a, b) => a.fullName.length - b.fullName.length,
      
      render: (text, record) => (
        <Link
          className=""
          to={`${route.employee}${route.employee_view}/${record.employeeCode}`}
        >
          {record.fullName}
        </Link>
      ),
    },
    {
      title: "Working Days",
      dataIndex: "noofworkingDaysPerWeek",
    },
    {
      title: "Mon",
      dataIndex: "monday",
    },
    {
      title: "Tues",
      dataIndex: "tuesday",
    },
    {
      title: "Wed",
      dataIndex: "wednesday",
    },
    {
      title: "Thu",
      dataIndex: "thursday",
    },
    {
      title: "Fri",
      dataIndex: "friday",
    },
    {
      title: "Sat",
      dataIndex: "saturday",
    },
    {
      title: "Sun",
      dataIndex: "sunday",
    },
    // {
    //   title: "Create User",
    //   dataIndex: "createUser",
    // },
    // {
    //   title: "Create Date",
    //   dataIndex: "createDate",
    //   render: (text) => {
    //     return text ? format(new Date(text), "dd-MM-yyyy") : "-";
    //   },
    // },
  ];

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    employeeData,
    searchColumns
  );

  const { onEmployeeExcelDownload } = useTableExport({
    columns: employeeFields,
    data: filteredData,
    fileName: "Employee Details",
    pdfTheme: "",
  });

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <Error404 error={error} />;
  }

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Employee Working Hours</h4>
                <h6>Manage your employee working hours</h6>
              </div>
            </div>

            <ReportTools
              columns={columns}
              data={filteredData}
              fileName={`Employee Working Hours Report`}
              pdfTheme="striped"
              refresh={refetch}
            />
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card table-list-card border-0">
                <div className="card-body">
                  <TableTop
                    onSearch={setSearchValue}
                    toggleFilterVisibility={toggleFilterVisibility}
                    isFilterVisible={isFilterVisible}
                    showToggle={false}
                  />

                  <div className="total-employees">
                    <h6>
                      <Users className="me-2" />
                      Total Employees <span>{filteredData?.length}</span>
                    </h6>
                  </div>

                  <div className="table-responsive">
                    <Spin spinning={isLoading || isFetching} size="large">
                      <Table
                        className="table table-hover table-center mb-0"
                        columns={columns}
                        dataSource={filteredData}
                        // scroll={{ x: "max-content", y: 600 }}
                        // sticky={true}
                        rowKey={(record) => record.uniqueId || record.id}
                        pagination={true}
                      />
                    </Spin>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmpWorkingHours;
